import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { idWindowPageSchema, type IdWindowPage, type IdWindowParams } from '../id-window';

// Import from generated schemas
const { ProductMovementFirestoreResponse } = schemas;

// Re-export schema for external use
export const ProductMovementResponseSchema = ProductMovementFirestoreResponse;

// Type exports
export type ProductMovementResponse = z.infer<typeof ProductMovementResponseSchema>;

// Query params
// Exactly the query parameters GET /product-movements declares. `limit` defaults to 100 there,
// so a caller that needs every row must page (ATL-1477).
interface GetProductMovementsParams {
  productId?: string;
  storeId?: string;
  startDate?: string;
  endDate?: string;
  type?: string;
  linkedDocId?: string;
  linkedDocType?: string;
  limit?: number;
  offset?: number;
}

// API factory function
export function createProductMovementsApi(client: TypedApiClient) {
  return {
    getProductMovements: (params?: GetProductMovementsParams): Promise<ProductMovementResponse[]> => {
      return client.get('/product-movements', {
        responseSchema: z.array(ProductMovementFirestoreResponse),
        params: params as Record<string, unknown>,
      });
    },

    /**
     * ATL-1477: one snapshot window of `/product-movements` — see `../id-window.ts`. Use it through
     * `readWholeList`, never directly: a single window is not the list.
     */
    getProductMovementsWindow: (
      params: {
      productId?: string;
      storeId?: string;
      type?: string;
      startDate?: string;
      endDate?: string;
      linkedDocId?: string;
      linkedDocType?: string;
      } & IdWindowParams,
    ): Promise<IdWindowPage<z.infer<typeof ProductMovementFirestoreResponse>>> => {
      return client.get('/product-movements/window', {
        params: params as Record<string, unknown>,
        responseSchema: idWindowPageSchema(ProductMovementFirestoreResponse),
      });
    },
  };
}
